import cleanseNumber from "../cleanseNumber";

/**
 * Dispatch a custom event
 * @param {String} eventCategory
 * @param {String} eventAction
 * @param {String} eventLabel
 * @param {Number} eventValue Should be an integer, 0 is accepted
 */
const customEvent = function (eventCategory, eventAction, eventLabel, eventValue = 0) {
    if (typeof eventCategory === 'object') {
        const eventObject = eventCategory;
        eventCategory = eventObject.category;
        eventAction = eventObject.action;
        eventLabel = eventObject.label;
        eventValue = eventObject.value;
    };
    dataLayer.push({
        'event': 'trackEvent',
        'eventCategory': eventCategory,
        'eventAction': eventAction,
        'eventLabel': eventLabel,
        'eventValue': parseInt(cleanseNumber(eventValue)),
    });
}

/**
 * Dispatch a custom event
 * @param {String} eventCategory
 * @param {String} eventAction
 * @param {String} eventLabel
 * @param {Number} eventValue Should be an integer, 0 is accepted
 */

/**
 * Dispatch an EventObject
 * @param {EventObject} eventObject
 */
const customEventObject = function (eventObject) {
    eventObject.dispatch();
}

/**
 * Dispatch a simulated page view event
 * @param {String} pageviewUrl
 * @param {String} pageviewTitle
 */
 const trackPageView = function (pageviewUrl, pageviewTitle) {
    dataLayer.push({
        'event': 'trackPageview',
        'pageviewUrl': pageviewUrl,
        'pageviewTitle': pageviewTitle,
    });
}

/**
 * GA4 generate lead event
 * @param {String} name Name of the event
 * @param {String} value Value (in currency) of the conversion. 0 is accepted
 * @param {String} currency Default GBP
 */
const generateLeadEvent = function (name = 'Misc Event', value = 0, currency = 'GBP') {
    dataLayer.push({
        'event': 'generateLead',
        'eventName': name,
        'eventValue': parseInt(cleanseNumber(value)),
        'eventCurrency': currency,
    });
}

export { customEvent, generateLeadEvent, customEventObject, trackPageView };